import styled from "styled-components";

const slides = [
  {
    image: require("../assets/images/socialimpact.webp"),
    title: "Social Impact",
    points: "The number of people positively affected.<br/> Demonstrated improvement in quality of life or a specific outcome.<br/> Measurable outcomes impacting the last mile.<br/> Overall improvement in life in a geography beyond numbers.",
  },
  {
    image: require("../assets/images/innovation.webp"),
    title: "Innovation",
    points: "Originality of the technology or solution.<br/> Accessibility of technology.<br/> Improvement over existing solutions.<br/> Focus on scientific research on new solutions.",
  },
  {
    image: require("../assets/images/scalable.webp"),
    title: "Scalability",
    points: "Potential for replication across regions.<br/> Scalable impact in remote geographies.<br/> Effective use of CSR resources.",
  },
  {
    image: require("../assets/images/sustain.webp"),
    title: "Sustainability",
    points: "Long-term viability (financial, environmental, social).<br/> Community ownership and participation.",
  },
];

export default function CardGrid() {
  return (
    <Wrapper>
      <Grid>
        {slides.map((item, index) => {
          // 🔥 Convert string → array safely
          const pointsArray = item.points
            ? item.points.split("<br/>").map(p => p.trim())
            : [];

          return (
            <Card key={index}>
              
              <ImageWrapper>
                <ImageBox>
                  <Image src={item.image} alt={item.title} />
                </ImageBox>
              </ImageWrapper>

              <Content>
                <Title>{item.title}</Title>

                <List>
                  {pointsArray.map((point, i) => (
                    <ListItem key={i}>{point}</ListItem>
                  ))}
                </List>
              </Content>

            </Card>
          );
        })}
      </Grid>
    </Wrapper>
  );
}

/* ================= STYLES ================= */

const Wrapper = styled.div`
  padding: 20px;

  @media (max-width: 768px) {
    padding: 6px;
}
`;

const Grid = styled.div`
  max-width: 1200px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 6px;
  }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
  transition: 0.3s;

  &:hover {
    transform: translateY(-8px);
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ImageBox = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 70%;
  height: 70%;
  object-fit: contain;
`;

const Content = styled.div`
  padding: 0px 18px 12px;
`;

const Title = styled.h3`
  font-size: 18px;
  color: #791e1b;
  margin-bottom: 10px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 16px;
}
`;

const List = styled.ul`
  margin-top: 10px;
  padding: 0;
  list-style: none;
`;

const ListItem = styled.li`
  position: relative;
  font-size: 13px;
  color: #555;
  line-height: 1.6;
  padding-left: 18px;
  margin-bottom: 4px;
  text-align: left;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    width: 6px;
    height: 6px;
    background: #791e1b;
    border-radius: 50%;
  }
`;
